import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateProjectMutationVariables = Types.Exact<{
  input: Types.UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject?: { __typename?: 'UpdateProjectPayload', project?: { __typename?: 'Project', id: string, description?: string | null, ignoreArchive: boolean, imageUrl?: string | null, name: string, private: boolean, mountedStorageDriveLetter?: Types.MountedStorageDriveLetter | null, mountedStorageStatus?: Types.MountedStorageStatus | null, images: { __typename?: 'Images', image128?: string | null, image256?: string | null, image32?: string | null, image64?: string | null, imageBase?: string | null, original?: string | null } } | null } | null };


export const UpdateProject = /*#__PURE__*/ gql`
    mutation UpdateProject($input: UpdateProjectInput!) {
  updateProject(input: $input) {
    project {
      id
      description
      ignoreArchive
      imageUrl
      name
      private
      mountedStorageDriveLetter
      mountedStorageStatus
      images {
        image128
        image256
        image32
        image64
        imageBase
        original
      }
    }
  }
}
    ` as unknown as DocumentNode<UpdateProjectMutation, UpdateProjectMutationVariables>;

          

          export const useUpdateProjectMutation = (options?:MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) => useMutation(UpdateProject, options);
          

          export type UpdateProjectMutationOptions = MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;

          

          export type UpdateProjectMutationResult = ReturnType<typeof useUpdateProjectMutation>[1];

          
